var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"tag",style:({'color': _vm.color, 'font-size': _vm.fontSize ? _vm.fontSize : null})},[_c('i',{class:_vm.icon}),_vm._v(" "),_c('span',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }